import { useEffect, useState } from "react";
import ContentWrapper from "../../views/components/ContentWrapper";
import { getHistory } from "../../data/dataApi";
import Pagination from "../../views/components/Pagination";
import { useNavigate, useParams } from "react-router-dom";
import { botTypes } from "../../views/helpers";
import DataSubMenu from "../../views/components/DataSubMenu";

const DashboardHistory = () => {
    const subNavOptions = [
        {
            id: "all",
            label: "All"
        },
        {
            id: "unanswered",
            label: "Unanswered"
        },
        {
            id: "pinned",
            label: "Pinned"
        }
    ];

    const { page, tab } = useParams();

    const [activeTab, setActiveTab] = useState(tab || subNavOptions[0].id);

    const [history, setHistory] = useState([]);
    const navigate = useNavigate();

    const listLimit = 30;

    useEffect(() => {
        (async () => {
            const response = await getHistory(page - 1 || 0, activeTab);

            if (response.success) {
                setHistory(response.data.rows);
            }
        })();
    }, [page, activeTab]);

    const handleNavigate = (sessionId) => {
        navigate(`/dashboard/history/${sessionId}`);
    }

    useEffect(() => {
        if (activeTab !== "all") {
            navigate(`/dashboard/history/page/1/${activeTab}`);
        } else {
            navigate("/dashboard/history");
        }
    }, [activeTab]);

    return (
        <ContentWrapper className="scrollable">
            <DataSubMenu
                subNavOptions={subNavOptions}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
            />

            <div className="wrapper">
                <div className="table-wrapper">
                    <table className="primary-table">
                        <thead>
                            <tr>
                                <td>ID</td>
                                <td className="text-truncate">Message</td>
                                <td>Date</td>
                                <td>Time</td>
                                <td>Country</td>
                                <td>User Email</td>
                                <td>Bot Type</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                history.map((entry) =>
                                    <tr key={entry.id} onClick={() => handleNavigate(entry.session_id)}>
                                        <td>{entry.id}</td>
                                        <td className="text-truncate">{entry.user_message}</td>
                                        <td>{new Date(entry.time).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                        <td>{new Date(entry.time).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</td>
                                        <td>{entry.country}</td>
                                        <td>{entry.user_email}</td>
                                        <td>{botTypes[entry.bot_type]}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>

                    <Pagination listLength={history.length && history[0].total_count} path="/dashboard/history" page={page} limit={listLimit} />
                </div>
            </div>
        </ContentWrapper>
    );
};

export default DashboardHistory;